"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkPWSQU33Njs = require('../chunk-PWSQU33N.js');


exports.en = _chunkPWSQU33Njs.en;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9